import React, { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../http';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import encryption from 'Utils/encryptionPassword';
import PasswordTooltipWrapper from 'Common/PasswordTooltipWrapper/PasswordTooltipWrapper';
import { PASSWORD_UPDATED_SUCCESSFULLY } from 'Common/ToastConstants';
import AuthWrapper from 'NewComponents/Wrappers/AuthWrapper';
import Button from './Button';
import FloatingAuthInput from 'NewComponents/FormComponents/FloatingAuthInput/FloatingAuthInput';


const UpdatePassword = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [password, setPassword] = useState({
        newPassword: "",
        confirmPassword: ""
    });
    const [searchParams] = useSearchParams();
    const onHandleChange = (e) => {
        const { name, value } = e.target;
        setPassword(prevPassword => ({
            ...prevPassword,
            [name]: value
        }));
        setError("");

    };

    const handleReset = async () => {
        const key = searchParams.get("trucarekey")
        const emailTo = searchParams.get("emailTo")
        if (password.newPassword === '') {
            setError("Password is required");
            return;
        }
        if (password.newPassword !== password.confirmPassword) {
            setError("Passwords do not match");
            return;
        }
        try {
            setLoading(true)
            const config = {
                headers: {
                    "Authorization": `Bearer ${key}` // Add any custom headers here
                }
            };
            let encryptPassword = encryption(password.newPassword);
            const payload = {
                email: emailTo,
                newPassword: encryptPassword
            }
            await api.post(`${process.env.REACT_APP_TC_AUTH}/api/Account/ResetPassword`, payload, config);
            toast.success(PASSWORD_UPDATED_SUCCESSFULLY)
            navigate('/login');
        } catch (error) {
            setLoading(false)
            ErrorHandlingMessage(error)
        }

    };

    const handleEnter = (e) => {
        if (e.charCode === 13) {
            handleReset();
        }
    };

    useEffect(() => {
        const key = searchParams.get("trucarekey");
        const emailTo = searchParams.get("emailTo");

        if (!key || !emailTo) {
            navigate('/login');
        }
    }, [navigate, searchParams]);

    return (
        <AuthWrapper heading="Update Password" subheading="Enter your new password to update your account.">
            <div className="max-w-md mx-auto mt-10">
                <div className="space-y-6">
                    <div>
                        <PasswordTooltipWrapper value={password.newPassword}  >
                            <FloatingAuthInput
                                id="newPassword"
                                label="New Password"
                                type="password"
                                placeholder="••••••••"
                                required
                                name="newPassword"
                                autoComplete="new-password" onKeyPress={handleEnter} value={password.newPassword}
                                onChange={onHandleChange}

                            />
                        </PasswordTooltipWrapper>
                    </div>

                    <div>
                        <PasswordTooltipWrapper value={password.confirmPassword}  >
                            <FloatingAuthInput
                                id="confirmPassword"
                                label="Confirm Password"
                                type="password"
                                placeholder="••••••••"
                                required
                                name="confirmPassword"
                                autoComplete="new-password" onKeyPress={handleEnter} value={password.confirmPassword}
                                onChange={onHandleChange}
                            />
                        </PasswordTooltipWrapper>
                        {error ? <p className='font-semibold rounded-sm text-rose-400 '>{error}</p> : ""}
                    </div>

                    <Button loading={loading} onClick={handleReset} variant="primary" fullWidth>
                        Update Password
                    </Button>

                </div>
            </div>
        </AuthWrapper>
    );
}

export default UpdatePassword;
